import { graphql } from 'react-relay/legacy.js';

export type {
    pdpRespMarketplaceSecondaryRootQuery$variables,
    pdpRespMarketplaceSecondaryRootQuery as pdpRespMarketplaceSecondaryRootQueryType,
} from './__generated__/pdpRespMarketplaceSecondaryRootQuery.graphql.ts';

export const pdpRespMarketplaceSecondaryRootQuery = graphql`
    query pdpRespMarketplaceSecondaryRootQuery(
        $itemId: String!
        $isTrade: Boolean!
        $itemIds: [String]!
        $fetchUser: Boolean!
        $guestId: String = ""
        $userId: String = ""
        $priceBookName: String = ""
        $afterDisplay: Boolean = false
        $afterDisplayAndBtNone: Boolean = false
        $personalizationId: String = ""
        $userCountryCode: String = ""
        $fetchSellerReviewsSection: Boolean = false
        $isRecentlyFavoritedPdpVariant: Boolean = false
        $isEstimateSimilarSoldVariant: Boolean = false
        $numOfSponsoredItems: Int = 30
        $maxSponsoredItems: Int
        $minSponsoredItemsSteps: [Int!]
    ) {
        viewer {
            ...PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer
        }
    }
`;
